import LocationSearch from '../../resources/js/_location_search';

( function( app ) {
  const COMPONENT = {
    className: 'shop-grid',
    selectedGroup: null,
    openGroups: [],
    init: function() {
      window.history.pushState( {
        page: window.location.href,
      }, '' );

      document.addEventListener( 'change', ( e ) => {
        if ( e.target.matches( '.js-shop-filter-input' ) ) {
          this.selectedGroup = e.target.closest( '.js-filter-group' );
          e.target.checked ? e.target.setAttribute( 'checked', 'checked' ) : e.target.removeAttribute( 'checked' );
          $( '#shop-filter [name="page"]' ).val( 1 );
          submit();
          e.preventDefault();
        }

        if ( e.target.matches( '#shop-pagination [name="page"]' ) ) {
          changePage( e.target.value );
          e.preventDefault();
        }

        if ( e.target.matches( '#shop-per-page [name="sort_by"]' ) ) {
          $( '#shop-filter [name="page"]' ).val( 1 );
          changeSortBy( e.target.value );
          e.preventDefault();
        }

        if ( e.target.matches( '#shop-per-page [name="per_page"]' ) ) {
          $( '#shop-filter [name="page"]' ).val( 1 );
          changePerPage( e.target.value );
          e.preventDefault();
        }
      }, true );

      window.addEventListener( 'submit', ( e ) => {
        if ( e.target.matches( '#shop-filter' ) || e.target.matches( '#shop-pagination' ) ) {
          e.preventDefault();
        }

        if ( e.target.matches( '#shop-pagination' ) ) {
          if ( e.submitter.matches( '[name="page"]' ) ) {
            changePage( e.submitter.value );
          }
        }
      } );

      const changePage = ( value ) => {
        if ( value === 1 ) {
          $( '#shop-filter [name="page"]' ).val( '' );
        } else {
          $( '#shop-filter [name="page"]' ).val( value );
        }
        submit();
      };

      const changeSortBy = ( value ) => {
        $( '#shop-filter [name="sort_by"]' ).val( value );
        submit();
      };

      const changePerPage = ( value ) => {
        $( '#shop-filter [name="per_page"]' ).val( value );
        submit();
      };

      window.addEventListener( 'preferredLocationChanged', ( e ) => {
        LocationSearch.getPreferredLocation();
        submit();
      } );

      document.addEventListener( 'click', ( e ) => {
        if ( e.target.matches( '.js-filter-pill' ) ) {
          e.preventDefault();
          const value = e.target.value;
          const input = document.querySelector( `.js-shop-filter-input[value="${value}"]` );
          if ( input && input.checked ) {
            e.target.remove();
            input.checked = false;
            submit();
          }
        }

        if ( e.target.matches( '.js-filter-toggle' ) ) {
          e.preventDefault();
          const group = e.target.closest( '.js-filter-group' );
          const groupKey = group.dataset.group;
          e.target.classList.toggle( 'is-open' );
          e.target.nextElementSibling.classList.toggle( 'is-open' );

          setTimeout( () => {
            if ( e.target.classList.contains( 'is-open' ) ) {
              this.openGroups.push( groupKey );
              $( e.target.nextElementSibling ).slideDown( () => {
                e.target.nextElementSibling.style.display = 'flex';
              } );
            } else {
              this.openGroups = this.openGroups.filter( ( group ) => group !== groupKey );
              $( e.target.nextElementSibling ).slideUp( () => {
                e.target.nextElementSibling.style.display = 'none';
              } );
            }
          }, 0 );
        }

        if ( e.target.matches( '.js-shop-mobile-toggle' ) ) {
          e.preventDefault();
          document.querySelector( '#shop-filter' ).classList.toggle( 'is-open' );
          document.querySelector( 'body' ).classList.toggle( 'overflow-hidden' );
        }
      } );

      window.addEventListener( 'popstate', function( e ) {
        if ( e.state && e.state.page ) {
          submit( e.state.page );
        }
      } );

      const submit = ( url ) => {
        const slug = url || getUrlFromFormData( document.querySelector( '#shop-filter' ) );
        fetch( slug )
            .then( ( response ) => response.text() )
            .then( ( html ) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString( html, 'text/html' );
              const shopGrid = doc.querySelector( '#shop-grid' );
              if ( shopGrid ) {
                this.openGroups.forEach( ( group ) => {
                  shopGrid.querySelector( `[data-group=${group}]` )?.classList.add( 'is-open' );
                } );
                document.querySelector( '#shop-grid' ).innerHTML = shopGrid.innerHTML;
                document.title = doc.title;
                const observer = new IntersectionObserver( ( entries ) => {
                  entries.forEach( ( entry ) => {
                    if ( entry.target.classList.contains( 'grid-top-placeholder' ) ) {
                      entry.target.classList.toggle( 'is-visible', entry.isIntersecting );
                    }
                  } );
                } );

                const topPlaceholder = document.querySelector( '.grid-top-placeholder' );
                if ( topPlaceholder ) {
                  observer.observe( topPlaceholder );
                }

                setTimeout( () => {
                  if ( !topPlaceholder.classList.contains( 'is-visible' ) ) {
                    window.scrollTo( {top: 0, behavior: 'instant'} );
                  }
                }, 0 );


                LocationSearch.getPreferredLocation();
                if ( !url ) {
                  window.history.pushState( {
                    page: slug,
                  }, '', slug );
                }
              }
            } )
            .catch( ( error ) => console.error( 'Error:', error ) );
      };

      function getUrlFromFormData( form ) {
        const formData = new FormData( form );
        const searchParams = new URLSearchParams( formData );
        if ( searchParams.get( 'page' ) === '1' ) {
          searchParams.delete( 'page' );
        }

        if ( searchParams.get( 's' )?.length === 0 ) {
          searchParams.delete( 's' );
        }

        let queryString = searchParams.toString();
        if ( queryString.length > 0 ) {
          queryString = `?${queryString}`;
        }
        return `${siteInfo.url}/shop/${queryString}`;
      }

      const observer = new IntersectionObserver( ( entries ) => {
        entries.forEach( ( entry ) => {
          if ( entry.target.classList.contains( 'grid-top-placeholder' ) ) {
            entry.target.classList.toggle( 'is-visible', entry.isIntersecting );
          }
        } );
      } );

      const topPlaceholder = document.querySelector( '.grid-top-placeholder' );
      if ( topPlaceholder ) {
        observer.observe( topPlaceholder );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'shop-grid', COMPONENT );
} )( app );
